import { StoreLocatorServiceModeTab } from './types';

export const STORE_LOCATOR_PICKUP_HREF = `/store-locator?tab=${StoreLocatorServiceModeTab.PICKUP}`;
export const STORE_LOCATOR_DELIVERY_HREF = `/store-locator?tab=${StoreLocatorServiceModeTab.DELIVERY}`;
